module.exports = __webpack_public_path__ + "img/welms_pic_fr.470e0f34.png";